import { createFileRoute } from "@tanstack/react-router"
import DesignSystemIndex from "~/pages/design-system/Index"

export const Route = createFileRoute("/_auth/internal/design-system/")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemIndex />
}
